<template>
  <v-main>
    <v-container grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <h1 class="mb-4">{{ ct.TitleText }} </h1>
          <v-layout row wrap></v-layout>
          <v-flex xs12 class="mb-4">
              <v-layout row wrap>
                <v-flex shrink><v-select class="ml-2" hide-details="true" :items="VT25List" v-model="selectedVT25" @change="saveVT25(selectedVT25)" :label="$t('Weight Indicator')"></v-select></v-flex>
                <v-flex grow></v-flex>
                <v-layout row wrap class="textsize-svs" style="padding: 5px 8px 4px 8px" >
                <v-flex d-flex xs12 sm9 class="textsize-large ml-1" style="min-height:60px; align-items:center; justify-content:center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
                            <div class="text-center" :style="getColorStr()">
                              {{displayWeight}} kg
                            </div>
                            <v-checkbox v-if="showTransferCheckBox" :label="$t('Transfer Registration')" class="ml-4 mt-4" v-model="transferRegistration" @change="TransferChanged" :color="'primary'"></v-checkbox>
                          </v-flex>
                </v-layout>
              </v-layout>
            </v-flex>
          <v-progress-linear v-if="loading" :indeterminate="true" ></v-progress-linear>
          <v-card v-else raised>
            <v-card-text>
              <v-form ref="form" v-model="valid">
                <v-select v-if="!isHide('Facility')" :readonly="readonlyFacility" :items="form.facilitiesDisplay" v-model="form.facilityDisplay" @change="facilityChanged" :label="$t('Facility')" :rules="(isRequired('Facility') ? [rules.required] : [])"></v-select>
                <v-flex xs12 mb6 class="mb-4">
                  <v-layout row wrap class="textsize-svs">
                    <v-flex d-flex xs10>
                      <v-autocomplete
                        v-if="!isHide('Vehicle')" :readonly="isReadonly('Vehicle')" :items="form.vehicles" v-model="form.vehicleNo" @change="vehicleChanged" v-on:keyup="searchVehicle = $event.target.value" @keyup="searchDelayed" :label="$t('Vehicle')" :rules="isRequired('Vehicle') ? [rules.required] : []"  @focus="focusVehicle" :no-data-text="ct.NoDataAvailable">
                        <template v-slot:append><v-btn v-if="!disableCreateVehicle" @click="newVehicleNo = (form.vehicles.length === 0 ? searchVehicle : ''); newVehicleDialog = true" color="primary" icon class="mb-n1 mr-n1"><v-icon>add</v-icon></v-btn></template>
                      </v-autocomplete>
                    </v-flex>
                    <v-layout row wrap class="textsize-svs">
                      <v-flex d-flex xs2 sm9>
                        <v-checkbox :label="$t('Remember')" class="ml-12" v-model="scanMobileSaved" @change="saveChanged" :color="'primary'"></v-checkbox>
                      </v-flex>
                    </v-layout>
                  </v-layout>
                </v-flex>
                <v-progress-linear v-if="searching" :indeterminate="true" class="mt-n6"></v-progress-linear>

                <v-autocomplete v-if="!isHide('Agreement')" :readonly="isReadonly('Agreement')" :items="form.agreements" v-model="form.agreementNo" :label="$t('Agreement')" @change="agreementChanged" v-on:keyup="searchAgreement = $event.target.value" @keyup="searchDelayedAgreement" :rules="(isRequired('Agreement') ? [rules.required] : [])"></v-autocomplete>
                <v-autocomplete v-if="!isHide('Delivery')" :readonly="isReadonly('Delivery')" :items="form.deliveries" v-model="form.deliveryNo" :label="$t('Delivery')" @change="deliveryChanged" :disabled="!form.agreementNo" :rules="(isRequired('Delivery') ? [rules.required] : [])" :no-data-text="ct.NoDataAvailable"></v-autocomplete>
                <v-autocomplete v-if="!isHide('Customer')" :readonly="isReadonly('Customer')" :items="form.customers" v-model="form.customerNo" v-on:keyup="searchCustomer = $event.target.value" @keyup="searchDelayedCustomer" :label="$t('Customer')" :rules="(isRequired('Customer') ? [rules.required] : [])"></v-autocomplete>
                <v-autocomplete v-if="!isHide('Article')" :readonly="isReadonly('Article')" :items="form.articles" v-model="form.articleNo" @change="articleChanged" :label="$t('Article')" :rules="(isRequired('Article') ? [rules.required] : [])"></v-autocomplete>
                <v-autocomplete v-if="!isHide('Carrier')" :readonly="isReadonly('Carrier')" :items="form.carriers" v-model="form.carrierNo" :label="$t('Carrier')" :rules="(isRequired('Carrier') ? [rules.required] : [])"></v-autocomplete>
                <v-text-field v-if="!isHide('RequisitionNo1')" :readonly="isReadonly('RequisitionNo1')" v-model="form.requisitionNo1" :label="$t('RequisitionNo1')" :rules="(isRequired('RequisitionNo1') ? [rules.required] : [])"></v-text-field>
                <v-text-field v-if="!isHide('RequisitionNo2')" :readonly="isReadonly('RequisitionNo2')" v-model="form.requisitionNo2" :label="$t('RequisitionNo2')" :rules="(isRequired('RequisitionNo2') ? [rules.required] : [])"></v-text-field>
                <v-autocomplete v-if="!isHide('Plant')" :readonly="isReadonly('Plant')" :items="form.plants" v-model="form.plantNo" :label="$t('Plant')" :rules="(isRequired('Plant') ? [rules.required] : [])"></v-autocomplete>
                <v-text-field v-if="!isHide('Comment')" :readonly="isReadonly('Comment')" v-model="form.comment1" :label="$t('Comment')" :maxlength="100" :rules="(isRequired('Comment') ? [rules.required] : [])"></v-text-field>
                <v-autocomplete v-if="!isHide('Storage')" :readonly="isReadonly('Storage')" :items="form.storages" v-model="form.storage1" :label="$t('Storage to count up')" :rules="(isRequired('Storage') ? [rules.required] : [])"></v-autocomplete>
                <v-autocomplete v-if="!isHide('Storage')" :readonly="isReadonly('Storage')" :items="form.storages" v-model="form.storage2" :label="$t('Storage to count down')" :rules="(isRequired('Storage') ? [rules.required] : [])"></v-autocomplete>
              </v-form>
              <v-form ref="formT" v-model="validT">
                <v-flex v-if="transferRegistration" d-flex xs4 class="font-weight-bold">{{$t("Transfer registration data")}}:</v-flex>
                <v-autocomplete v-if="!isHideT('Agreement')" :readonly="isReadonly('Agreement')" :items="formT.agreements" v-model="formT.agreementNo" :label="$t('Agreement')" @change="agreementChangedT" v-on:keyup="searchAgreementT = $event.target.value" @keyup="searchDelayedAgreementT" :rules="(isRequired('Agreement') ? [rules.required] : [])"></v-autocomplete>
                <v-autocomplete v-if="!isHideT('Delivery')" :readonly="isReadonly('Delivery')" :items="formT.deliveries" v-model="formT.deliveryNo" :label="$t('Delivery')" @change="deliveryChangedT" :disabled="!formT.agreementNo" :rules="(isRequired('Delivery') ? [rules.required] : [])" :no-data-text="ct.NoDataAvailable"></v-autocomplete>
                <v-autocomplete v-if="!isHideT('Customer')" :readonly="isReadonly('Customer')" :items="formT.customers" v-model="formT.customerNo" v-on:keyup="searchCustomerT = $event.target.value" @keyup="searchDelayedCustomerT" :label="$t('Customer')" :rules="(isRequired('Customer') ? [rules.required] : [])"></v-autocomplete>
                <v-autocomplete v-if="!isHideT('Article')" :readonly="isReadonly('Article')" :items="formT.articles" v-model="formT.articleNo" @change="articleChangedT" :label="$t('Article')" :rules="(isRequired('Article') ? [rules.required] : [])"></v-autocomplete>
                <v-autocomplete v-if="!isHideT('Carrier')" :readonly="isReadonly('Carrier')" :items="formT.carriers" v-model="formT.carrierNo" :label="$t('Carrier')" :rules="(isRequired('Carrier') ? [rules.required] : [])"></v-autocomplete>
                <v-text-field v-if="!isHideT('RequisitionNo1')" :readonly="isReadonly('RequisitionNo1')" v-model="formT.requisitionNo1" :label="$t('RequisitionNo1')" :rules="(isRequired('RequisitionNo1') ? [rules.required] : [])"></v-text-field>
                <v-text-field v-if="!isHideT('RequisitionNo2')" :readonly="isReadonly('RequisitionNo2')" v-model="formT.requisitionNo2" :label="$t('RequisitionNo2')" :rules="(isRequired('RequisitionNo2') ? [rules.required] : [])"></v-text-field>
                <v-autocomplete v-if="!isHideT('Plant')" :readonly="isReadonly('Plant')" :items="formT.plants" v-model="formT.plantNo" :label="$t('Plant')" :rules="(isRequired('Plant') ? [rules.required] : [])"></v-autocomplete>
                <v-text-field v-if="!isHideT('Comment')" :readonly="isReadonly('Comment')" v-model="formT.comment1" :label="$t('Comment')" :maxlength="100" :rules="(isRequired('Comment') ? [rules.required] : [])"></v-text-field>
                <v-autocomplete v-if="!isHideT('Storage')" :readonly="isReadonly('Storage')" :items="formT.storages" v-model="formT.storage1" :label="$t('Storage to count up')" :rules="(isRequired('Storage') ? [rules.required] : [])"></v-autocomplete>
                <v-autocomplete v-if="!isHideT('Storage')" :readonly="isReadonly('Storage')" :items="formT.storages" v-model="formT.storage2" :label="$t('Storage to count down')" :rules="(isRequired('Storage') ? [rules.required] : [])"></v-autocomplete>
              </v-form>
            </v-card-text>
            <v-layout row wrap>
                  <v-flex xs12 md6>
                    <v-layout row wrap class="textsize-large mb-n4" style="padding: 2px 2px 2px 14px">
                      <v-flex d-flex xs4 class="font-weight-bold">{{$t("1. weight")}}:</v-flex>
                      <v-flex d-flex xs4 class="font-weight-bold" style="justify-content:right" :style="getColorWeightStr(true)">{{weightFirst}} kg</v-flex>
                      <v-btn v-if="tempTareSet" :readonly="isValidWieght()" @click="preClearTare" color="green" class="ml-4 mt-1">
                        <v-icon color="white">lock</v-icon>
                      </v-btn>
                      <v-btn v-if="tempTareNotSet" :readonly="isValidWieght()" @click="preSaveTare" color="white" class="ml-4 mt-1">
                        <v-icon color="black">lock</v-icon>
                      </v-btn>
                    </v-layout>
                    <v-layout row wrap class="textsize-large mb-n4" style="padding: 2px 2px 2px 14px">
                      <v-flex d-flex xs4 class="font-weight-bold">{{$t("2. weight")}}:</v-flex>
                      <v-flex d-flex xs4 class="font-weight-bold" style="justify-content:right" :style="getColorWeightStr(false)">{{weightSecond}} kg</v-flex>
                    </v-layout>
                    <v-layout row wrap class="textsize-large mb-n4" style="padding: 2px 2px 2px 14px">
                      <v-flex d-flex xs4 class="font-weight-bold">{{$t("Netto")}}:</v-flex>
                      <v-flex d-flex xs4 class="font-weight-bold" style="justify-content:right">{{weightNet}} kg</v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
            <v-card-actions>
              <v-flex xs12 text-right>
              <v-spacer></v-spacer>
              <v-btn v-if="!showSaveButton" class="mr-1 mb-1" color="primary" @click="preFinish" :disabled="validate(smReg)">{{$t(textBtnText)}}</v-btn>
              <v-btn v-if="showEnterButton" class="mr-1 mb-1" @click="save('gotoSetWeight')" :color="'primary'">
                {{$t("Enter")}} {{buttonAppend}}{{smReg.comment ? ' (' + smReg.comment + ')' : ''}}
              </v-btn>
              <v-btn v-if="showSaveButton" class="mr-1 mb-1" :loading="saving" min-width="97px" :disabled="!valid" @click.prevent="saveChangedFirstReg" color="success">{{ct.SaveBtnText}} {{buttonAppend}}</v-btn>
              <v-btn class="mr-1 mb-1" color="primary" @click="preventLeave = false; $router.go(-1)">{{$t("Cancel")}}</v-btn>
              </v-flex>
            </v-card-actions>
          </v-card>
        </v-flex>

       <!-- NEW VEHICLE DIALOG -->
        <v-dialog v-model="newVehicleDialog" max-width="300" persistent>
          <v-card >
            <v-card-title class="headline">{{$t('Create') + ' ' + $t('New').toLowerCase() + ' ' + $t('Vehicle')}}</v-card-title>
            <v-divider class="mb-n4"></v-divider>
            <v-card-actions>
              <v-card-text>
                <v-text-field class="mb-4" v-model="newVehicleNo" autofocus hide-details="true" :label="$t('No.')" :rules="[rules.required]"></v-text-field>
                <v-text-field class="mb-4" v-model="newVehicleName" hide-details="true" :label="ct.Name"></v-text-field>
                <v-text-field class="mb-4 licensplate-input" :value="newVehicleLicensePlateNo" v-model="newVehicleLicensePlateNo" hide-details="true" :label="$t('VehicleLicensePlateNo')" :rules="[rules.required]" @keydown.space.prevent></v-text-field>
                <v-btn class="ml-8 mt-6" color="success" @click="newVehicleDialog = false; saveVehicle()" >{{$t("Save")}}</v-btn>
                <v-btn class="ml-6 mt-6" color="primary" @click="newVehicleDialog = false">{{$t("Cancel")}}</v-btn>
            </v-card-text>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="areYouSureFinishDialog" max-width="400" persistent>
        <v-card>
          <v-card-title class="headline">{{$t("Finish")}}?</v-card-title>
          <template>
            <v-card-text class="font-weight-bold">{{$t(textFinishText)}}</v-card-text>
          </template>
          <v-card-actions>
            <v-spacer></v-spacer>
              <template>
                <v-btn ref="yesButton" color="success" @click="areYouSureFinishDialog = false; capture()">{{$t("Yes")}}</v-btn>
                <v-btn ref="noButton" color="primary" @click="areYouSureFinishDialog = false" autofocus>{{$t("No")}}</v-btn>
              </template>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog
          v-model="areYouSureSaveTare" max-width="400" persistent>
        <v-card>
          <v-card-title class="headline">{{$t("Save")}}?</v-card-title>
          <template>
            <v-card-text class="font-weight-bold">{{$t("Do you want to use")+" " + displayWeight + " " }} {{$t("kg as empty weight?")}}</v-card-text>
          </template>
          <v-card-actions>
            <v-spacer></v-spacer>
              <template>
                <v-btn ref="yesButton" color="success" @click="areYouSureSaveTare = false; saveTare(smReg.Id)">{{$t("Yes")}}</v-btn>
                <v-btn ref="noButton" color="primary" @click="areYouSureSaveTare = false" autofocus>{{$t("No")}}</v-btn>
              </template>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog
          v-model="areYouSureClearTare" max-width="400" persistent>
        <v-card>
          <v-card-title class="headline">{{$t("Clear")}}?</v-card-title>
          <template>
            <v-card-text class="font-weight-bold">{{$t("Do you want to remove the temporary empty weight?")}}</v-card-text>
          </template>
          <v-card-actions>
            <v-spacer></v-spacer>
              <template>
                <v-btn ref="yesButton" color="success" @click="areYouSureClearTare = false; clearTare(smReg.Id)">{{$t("Yes")}}</v-btn>
                <v-btn ref="noButton" color="primary" @click="areYouSureClearTare = false" autofocus>{{$t("No")}}</v-btn>
              </template>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog
    v-model="waitForCaptureDialog" max-width="350">
    <v-card>
      <v-card-title class="headline">{{$t("Image Capture")}}</v-card-title>
      <v-card-text>{{$t("Please wait, while system captures images…")}}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
          <!--<v-btn ref="yesButton" color="success" @click="waitForCaptureDialog = false;">{{$t("Yes")}}</v-btn>-->
      </v-card-actions>
    </v-card>
    </v-dialog>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import { app } from '@/main'
import * as Archive from '@/core/archive'
import * as ScanMobile from '@/modules/scan-mobile/scan-mobile'
import ct from '@/core/mixins/common-translations'
import rules from '@/core/mixins/common-rules'
import preventLeave from '@/core/mixins/preventLeave'
import * as LocalStorage from '@/core/local-storage'
import * as Security from '@/core/security'
import { validSearchKeyUp } from '@/core/utils'
import _ from 'lodash' // clone

export default {
  mixins: [ct, rules, preventLeave],
  data: () => ({
    dataType: 'scan-mobile-registration',
    loading: true,
    saving: false,
    valid: true,
    validT: true,
    readonlyFacility: true, // Prevent errors: true when editing registration, false when creating new registration
    hiddenFields: [],
    readonlyFields: [],
    requiredFields: [],
    redirectTo: 'scan-mobile-registrations',
    redirectToSetWeight: 'add-scan-mobile-weight',
    searchVehicle: '',
    searchCustomer: '',
    searchCustomerT: '',
    searchAgreement: '',
    searchAgreementT: '',
    searchTimer: null,
    searching: false,
    textBtnText: '2. Registration',
    textFinishText: 'Do you want to finish 2. Registration.',
    areYouSureFinishDialog: false,
    newVehicleDialog: false,
    showSaveButton: false,
    newVehicleNo: null,
    newVehicleName: null,
    newVehicleLicensePlateNo: null,
    articleNoFilter: null,
    articleNoFilterT: null,
    agreementNoFilter: null,
    selectedVT25: null,
    VT25List: [],
    WeightNet: 0,
    displayWeight: '',
    showFinishDialog: false,
    showCancelDialog: false,
    showClearTareDialog: false,
    showSaveTareDialog: false,
    showTransferCheckBox: false,
    showEnterButton: false,
    camDelayEnabled: false,
    camDelay: 0,
    weightNet: 0,
    weightFirst: 0,
    weightSecond: 0,
    firstReg: true,
    orgFirstReg: true,
    secondRegistration: false,
    scanMobileSaved: false,
    transferRegistration: false,
    tempTareSet: false,
    tempTareNotSet: false,
    areYouSureSaveTare: false,
    areYouSureClearTare: false,
    disableCreateVehicle: true,
    tareVehicle: false,
    tempTareValue: 0,
    tareValue: 0,
    isStable: false,
    vehicleId: '',
    userVehicleNo: '',
    useFacilityDescription: false,
    storageNo: '',
    waitForCaptureDialog: false,
    showUp: false,
    showDown: false,
    form: {
      facilities: [],
      articles: [],
      agreements: [],
      deliveries: [],
      customers: [],
      vehicles: [],
      plants: [],
      carriers: [],
      storages: [],
      facilityNo: '',
      facilitiesDescription: [],
      facilityDescription: '',
      facilityDisplay: '',
      facilitiesDisplay: [],
      articleNo: '',
      agreementNo: '',
      deliveryNo: '',
      carrierNo: '',
      customerNo: '',
      vehicleNo: '',
      vehicleLicensePlateNo: '',
      requisitionNo1: '',
      requisitionNo2: '',
      comment1: '',
      plantNo: '',
      searchCriteria: '',
      top: 100,
      manualIndicator: false,
      storage1: '',
      storage2: ''
    },
    formT: {
      facilities: [],
      articles: [],
      agreements: [],
      deliveries: [],
      customers: [],
      vehicles: [],
      plants: [],
      carriers: [],
      storages: [],
      facilityNo: '',
      facilitiesDescription: [],
      facilityDescription: '',
      facilityDisplay: '',
      facilitiesDisplay: [],
      articleNo: '',
      agreementNo: '',
      deliveryNo: '',
      carrierNo: '',
      customerNo: '',
      vehicleNo: '',
      vehicleLicensePlateNo: '',
      requisitionNo1: '',
      requisitionNo2: '',
      comment1: '',
      plantNo: '',
      searchCriteria: '',
      top: 100,
      manualIndicator: false,
      storage1: '',
      storage2: ''
    },
    id: undefined, // for Create/Edit support in TitleText
    smReg: {
      id: '00000000-0000-0000-0000-000000000000',
      registrationId: '00000000-0000-0000-0000-000000000000',
      facilityNo: null,
      finishedDate: null,
      finishedBy: null,
      comment: null,
      reg: null
    }
  }),
  computed: {
  },
  methods: {
    searchDelayed (val) {
      // Only normal/Backspace/Delete keys must start a search
      if (validSearchKeyUp(val.keyCode)) {
        if (this.searchTimer) clearTimeout(this.searchTimer)
        this.searchTimer = setTimeout(this.searchVehicles, 600)
      }
    },
    searchDelayedCustomer (val) {
      // Only normal/Backspace/Delete keys must start a search
      if (validSearchKeyUp(val.keyCode)) {
        if (this.searchTimer) clearTimeout(this.searchTimer)
        this.searchTimer = setTimeout(this.searchCustomers, 600)
      }
    },
    searchDelayedCustomerT (val) {
      // Only normal/Backspace/Delete keys must start a search
      if (validSearchKeyUp(val.keyCode)) {
        if (this.searchTimer) clearTimeout(this.searchTimer)
        this.searchTimer = setTimeout(this.searchCustomersT, 600)
      }
    },
    searchDelayedAgreement (val) {
      // Only normal/Backspace/Delete keys must start a search
      if (validSearchKeyUp(val.keyCode)) {
        if (this.searchTimer) clearTimeout(this.searchTimer)
        this.searchTimer = setTimeout(this.searchAgreements, 600)
      }
    },
    searchDelayedAgreementT (val) {
      // Only normal/Backspace/Delete keys must start a search
      if (validSearchKeyUp(val.keyCode)) {
        if (this.searchTimer) clearTimeout(this.searchTimer)
        this.searchTimer = setTimeout(this.searchAgreementsT, 600)
      }
    },
    searchVehicles () {
      if (this.searchVehicle.length < 1) this.form.vehicles = []
      // Temporary show Search vehicle xxx ....
      this.form.vehicles = [this.searchVehicle.length ? this.$t('Searching') + ' ' + this.searchVehicle + ' ...' : this.$t('Search')]
      // Only update if not already searching and serarch text is entered
      if (!this.searching && this.searchVehicle) this.updateVehicles(this.searchVehicle)
    },
    searchCustomers () {
      if (this.searchCustomer.length < 1) this.form.customers = []
      // Temporary show Search customer xxx ....
      this.form.customers = [this.searchCustomer.length ? this.$t('Searching') + ' ' + this.searchCustomer + ' ...' : this.$t('Search')]
      // Only update if not already searching and serarch text is entered
      if (!this.searching && this.searchCustomer) this.updateCustomers(this.searchCustomer)
    },
    searchCustomersT () {
      if (this.searchCustomerT.length < 1) this.formT.customers = []
      // Temporary show Search customer xxx ....
      this.formT.customers = [this.searchCustomerT.length ? this.$t('Searching') + ' ' + this.searchCustomerT + ' ...' : this.$t('Search')]
      // Only update if not already searching and serarch text is entered
      if (!this.searching && this.searchCustomerT) this.updateCustomersT(this.searchCustomerT)
    },
    searchAgreements () {
      if (this.searchAgreement.length < 1) this.form.agreements = []
      // Temporary show Search agreement xxx ....
      this.form.agreements = [this.searchAgreement.length ? this.$t('Searching') + ' ' + this.searchAgreement + ' ...' : this.$t('Search')]
      // Only update if not already searching and serarch text is entered
      if (!this.searching && this.searchAgreement) this.updateAgreements(this.searchAgreement)
    },
    searchAgreementsT () {
      if (this.searchAgreementT.length < 1) this.formT.agreements = []
      // Temporary show Search agreement xxx ....
      this.formT.agreements = [this.searchAgreementT.length ? this.$t('Searching') + ' ' + this.searchAgreementT + ' ...' : this.$t('Search')]
      // Only update if not already searching and serarch text is entered
      if (!this.searching && this.searchAgreementT) this.updateAgreementsT(this.searchAgreementT)
    },
    stopWeightTimer () {
      if (this.getLiveWeightTimer) {
        this.checkkingIsAlive = false
        this.activeVT25 = false
        clearInterval(this.getLiveWeightTimer)
      }
      if (this.getRegTimer) clearInterval(this.getRegTimer)
    },
    saveChangedFirstReg () {
      this.formToObject()
      this.saveReg()
    },
    isValidWieght () {
      return this.weightNet > 0
    },
    validate (item) {
      return !this.isStable
    },
    getColorStr () {
      if (this.isStable || this.manualIndicator) {
        return 'color:black'
      } else {
        return 'color:red'
      }
    },
    getColorWeightStr (first) {
      if (this.manualIndicator) {
        return 'color:black'
      }
      if (first) {
        if (!this.firstReg) {
          return 'color:black'
        }
        if (this.isStable) {
          return 'color:black'
        } else {
          return 'color:red'
        }
      } else {
        if (this.firstReg) {
          return 'color:black'
        } else {
          if (this.isStable) {
            return 'color:black'
          } else {
            return 'color:red'
          }
        }
      }
    },
    async ValidateValue (value) {
      if (value === null || value === undefined) {
        // console.log('pip1 not set-', value)
        return false
      }
      if (value.length < 1) {
        // console.log('pip2 blank-', value)
        return false
      }
      // console.log('pip ok-', value)
      return true
    },
    async ValidateRequiredField () {
      var valid = true
      if (!await this.ValidateValue(this.form.vehicleNo) && this.isRequired('Vehicle')) {
        return false
      }
      if (!await this.ValidateValue(this.form.agreementNo) && this.isRequired('Agreement')) {
        return false
      }
      if (!await this.ValidateValue(this.form.deliveryNo) && this.isRequired('Delivery')) {
        return false
      }
      if (!await this.ValidateValue(this.form.customerNo) && this.isRequired('Customer')) {
        return false
      }
      if (!await this.ValidateValue(this.form.articleNo) && this.isRequired('Article')) {
        return false
      }
      if (!await this.ValidateValue(this.form.carrierNo) && this.isRequired('Carrier')) {
        return false
      }
      if (!await this.ValidateValue(this.form.requisitionNo1) && this.isRequired('RequisitionNo1')) {
        return false
      }
      if (!await this.ValidateValue(this.form.requisitionNo2) && this.isRequired('RequisitionNo2')) {
        return false
      }
      if (!await this.ValidateValue(this.form.plantNo) && this.isRequired('Plant')) {
        return false
      }
      if (!await this.ValidateValue(this.form.comment1) && this.isRequired('Comment')) {
        return false
      }
      return valid
    },
    capture () {
      if (this.camDelayEnabled) {
        if (!this.waitForCaptureDialog) {
          const res = ScanMobile.captureImageMsg({ facilityNo: this.form.facilityNo, corpName: Security.user.corporation, vehicleNo: this.form.vehicleNo, indicator: this.selectedVT25 })
          if (!res.failed) {
            this.waitForCaptureDialog = true
            this.startCaptureTimer()
          }
        } else {
          this.handleSave()
        }
      } else {
        this.handleSave()
      }
    },
    async preFinish () {
      if (this.showFinishDialog) {
        this.areYouSureFinishDialog = true
      } else {
        if (this.camDelayEnabled) {
          if (!this.waitForCaptureDialog) {
            const res = ScanMobile.captureImageMsg({ facilityNo: this.form.facilityNo, corpName: Security.user.corporation, vehicleNo: this.form.vehicleNo, indicator: this.selectedVT25 })
            if (!res.failed) {
              this.waitForCaptureDialog = true
              this.startCaptureTimer()
            }
          } else {
            this.handleSave()
          }
        } else {
          this.handleSave()
        }
      }
    },
    startCaptureTimer () {
      this.waitForCaptureDialog = true
      this.getRegTimer = setInterval(() => {
        if (this.waitForCaptureDialog) {
          this.waitForCaptureDialog = false
          clearInterval(this.getRegTimer)
          this.handleSave()
        }
      }, this.camDelay * 1000)
    },
    async handleSave () {
      const res = await this.ValidateRequiredField()
      if (!res) {
        this.$root.$message.showError(this.$t('Please add required fields'))
        return
      }

      if (this.firstReg && !this.tareVehicle) {
        this.smReg.WeightFirst = this.weightFirst
        if (this.smReg.WeightFirst < 1) {
          this.$root.$message.showError(this.$t('Invalid weight. Please fix and retry') + ' (0 kg)')
          return
        }

        if (this.transferRegistration) {
          this.smReg.transferRegistration = this.formT
        }
        this.saveReg()
        return
      }
      if (this.tareVehicle || this.tempTareValue != null) {
        await this.formToObject()
        if (this.smReg.Id === undefined) {
          this.smReg.Id = '00000000-0000-0000-0000-000000000000'
        }
        this.smReg.WeightFirst = this.weightSecond
        if (this.transferRegistration) {
          this.smReg.transferRegistration = this.formT
        }
        this.finishRegistration(this.smReg.Id)
        return
      }
      this.finishRegistration(this.smReg.Id)
    },
    preSaveTare () {
      if (this.showSaveTareDialog) {
        this.areYouSureSaveTare = true
      } else {
        this.saveTare(this.smReg.Id)
      }
    },
    preClearTare () {
      if (this.showClearTareDialog) {
        this.areYouSureClearTare = true
      } else {
        this.clearTare(this.smReg.Id)
      }
    },
    clearTare (id) {
      const res = ScanMobile.clearTempTare(this.vehicleId)
      if (!res.failed) {
        this.tempTareValue = null
        if (this.tempTareValue === null) {
          this.tempTareNotSet = true
          this.tempTareSet = false
        } else {
          this.tempTareNotSet = false
          this.tempTareSet = true
        }
      }
      this.preventLeave = false
      this.$router.push({ name: this.redirectTo })
    },
    saveTare (id) {
      this.tempTareValue = this.WeightNet
      const res = ScanMobile.setTempTare({ VehicleId: this.vehicleId, Weight: this.tempTareValue })
      if (!res.failed) {
        if (this.tempTareValue === null) {
          this.tempTareNotSet = true
          this.tempTareSet = false
        } else {
          this.tempTareNotSet = false
          this.tempTareSet = true
          this.firstReg = false
          this.firstReg = false
          this.textBtnText = '2. Registration'
          this.textFinishText = 'Do you want to finish 2. Registration.'
        }
      } else {
        this.tempTareValue = null
      }
      // this.preventLeave = false
      // this.$router.push({ name: this.redirectTo })
    },
    saveChanged () {
      LocalStorage.save('RecallData', this.scanMobileSaved)
    },
    TransferChanged () {
      if (this.transferRegistration) {
        this.updateUiT()
      }
      LocalStorage.save('transferRegistration', this.transferRegistration)
    },
    focusVehicle () {
      // Temporary show Search
      if (this.form.vehicles.length !== 1) this.form.vehicles = [this.$t('Search')]
    },
    async updateVehicles (search) {
      this.searching = true
      // "search" for one vehicle (single lookup)
      if (search.length === 1) {
        const res = await Archive.loadVehicle({ facilityNo: this.form.facilityNo, vehicleNo: search })
        if (!res.failed) {
          if (res.data) {
            const item = res.data
            this.form.vehicles = [{
              text: [item.No, item.LicensePlateNo].filter(Boolean).join(' - '),
              value: item.No,
              obj: item
            }]
            this.smReg.TareWeight = Math.round(res.data.Details.find(o => o.Name === 'TareWeight')?.Value ?? 0)
            if (this.smReg.TareWeight > 0) {
              this.tareVehicle = true
            } else {
              this.tareVehicle = false
            }
          } else {
            this.form.vehicles = []
          }
        }
      } else { // search for many vehicles (via searchText)
        const res = await ScanMobile.loadVehicles({ facility: this.form.facilityNo, searchText: search })
        if (!res.failed) {
          this.form.vehicles = res.data.map(item => {
            return {
              text: [item.No, item.LicensePlateNo].filter(Boolean).join(' - '),
              value: item.No,
              obj: item
            }
          })
        }
      }
      this.searching = false
    },
    async updateCustomers (search) {
      this.searching = true
      const res = await Archive.loadCustomers({ facilityNo: this.form.facilityNo, searchCriteria: search, top: this.form.top })
      if (!res.failed) {
        this.form.customers = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }

      this.searching = false
    },
    async updateCustomersT (search) {
      this.searching = true
      const res = await Archive.loadCustomers({ facilityNo: this.form.facilityNo, searchCriteria: search, top: this.formT.top })
      if (!res.failed) {
        this.formT.customers = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }

      this.searching = false
    },
    async updateAgreements (search) {
      this.searching = true
      const res = await Archive.loadAgreements({ facilityNo: this.form.facilityNo, searchCriteria: search, top: this.form.top, agreementNoFilter: this.agreementNoFilter })
      if (!res.failed) {
        this.form.agreements = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }

      this.searching = false
    },
    async updateAgreementsT (search) {
      this.searching = true
      const res = await Archive.loadAgreements({ facilityNo: this.form.facilityNo, searchCriteria: search, top: this.formT.top, agreementNoFilterT: this.agreementNoFilterT })
      if (!res.failed) {
        this.formT.agreements = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }

      this.searching = false
    },
    async handleSingleTareNo () {
      this.weightFirst = 0
      this.weightSecond = 0
      this.tempTareSet = false
      this.tempTareNotSet = false
      this.TempTareVehicle = false
      this.tareVehicle = false
      this.smReg.Registration = null
      var res = await Archive.loadVehicle({ facilityNo: this.form.facilityNo, vehicleNo: this.form.vehicleNo })
      if (!res.failed) {
        const rMethod = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'RegistrationMethod')
        if (rMethod === '1') {
          this.tareVehicle = true
          this.tempTareSet = false
          this.tempTareNotSet = false
          this.TempTareVehicle = false
          this.firstReg = false
          this.textBtnText = '2. Registration'
          this.weightFirst = parseInt(this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'TareWeight'))
          this.tareValue = this.weightFirst
        } else {
          const data = await ScanMobile.getTempTare(res.data.Id)
          this.vehicleId = res.data.Id
          this.tempTareValue = data.data
          if (this.tempTareValue === null) {
            this.tempTareNotSet = true
            this.tempTareSet = false
            const res = await ScanMobile.loadFirstRegistration({ Facility: this.form.facilityNo, VehicleNo: this.form.vehicleNo })
            if (!res.failed) {
              if (res.data != null) {
                this.secondRegistration = true
                this.weightFirst = res.data.Registration.WeightFirst
                this.smReg.Registration = res.data.Registration
                this.smReg.Facility = res.data.Registration.Facility
                this.smReg.Id = res.data.Id
                this.smReg.RegistrationId = res.data.RegistrationId
                this.firstReg = false
                this.textBtnText = '2. Registration'
                this.textFinishText = 'Do you want to finish 2. Registration.'
              } else {
                this.firstReg = true
                this.textBtnText = '1. Registration'
                this.textFinishText = 'Do you want to finish 1. Registration.'
              }
            }
          } else {
            this.tempTareNotSet = false
            this.tempTareSet = true
            this.firstReg = false
            this.textBtnText = '2. Registration'
            this.textFinishText = 'Do you want to finish 2. Registration.'
          }
        }
      }
    },
    async loadVehicle (search, changeVehicle, noAgreementLoad = false) {
      const res = await Archive.loadVehicle({ facilityNo: this.form.facilityNo, vehicleNo: search })
      if (!res.failed) {
        if (res.data) {
          const item = res.data
          this.form.vehicles = [{
            text: [item.No, item.LicensePlateNo].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }]
          this.smReg.TareWeight = Math.round(res.data.Details.find(o => o.Name === 'TareWeight')?.Value ?? 0)
          if (this.smReg.TareWeight > 0) {
            this.tareVehicle = true
          } else {
            this.tareVehicle = false
          }
          if (changeVehicle) this.vehicleChanged(noAgreementLoad) // on new: all reference fields are updated
          if (!changeVehicle) { // on edit: filtered articles and agreements are loaded (Valid Choice)
            this.articleNoFilter = this.getData1FromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'ValidArticles')
            this.agreementNoFilter = this.getData1FromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'ValidAgreements')
            this.loadFilteredArticles()
            this.loadAgreement(this.form.agreementNo)

            this.articleNoFilterT = this.getData1FromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'ValidArticles')
            this.agreementNoFilterT = this.getData1FromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'ValidAgreements')
            this.loadFilteredArticlesT()
            this.loadAgreementT(this.formT.agreementNo)
          }
        }
      }
    },
    async saveVehicle () {
      // Check newVehicleNo does not already exist
      let foundNo = false
      var res = await Archive.loadVehicle({ facilityNo: this.form.facilityNo, vehicleNo: this.newVehicleNo })
      if (!res.failed && res.data && res.data.No === this.newVehicleNo) { foundNo = true }

      // Check newVehicleLicensePlateNo does not already exist
      let foundLicensePlate = false
      if (!foundNo) {
        this.newVehicleLicensePlateNo = this.newVehicleLicensePlateNo.toUpperCase()
        res = await ScanMobile.loadVehicles({ facility: this.form.facilityNo, searchText: this.newVehicleLicensePlateNo })
        if (!res.failed && res.data && res.data.find(v => v.LicensePlateNo.toUpperCase() === this.newVehicleLicensePlateNo) != null) { foundLicensePlate = true }
      }

      // Save new vehicle
      if (!foundNo && !foundLicensePlate) {
        const vehicle = {
          Id: '00000000-0000-0000-0000-000000000000',
          Facility: this.form.facilityNo,
          No: this.newVehicleNo,
          Name: this.newVehicleName,
          LicensePlateNo: this.newVehicleLicensePlateNo,
          Details: []
        }
        res = await Archive.saveVehicle(vehicle)
        if (!res.failed) {
          // Refresh Vehicle field
          this.searchVehicle = this.newVehicleNo
          this.updateVehicles(this.searchVehicle)
          this.form.vehicleNo = this.newVehicleNo
          this.$root.$message.showSuccess(this.$t('Vehicle') + ' ' + this.newVehicleNo + ' ' + this.$t('Saved').toLowerCase())
        }
      } else { this.$root.$message.showError(this.$t('Vehicle') + ' ' + (foundNo ? this.newVehicleNo : '') + (foundLicensePlate ? this.newVehicleLicensePlateNo : '') + ' ' + this.$t('already exists')) }

      // clean dialog
      this.newVehicleNo = ''
      this.newVehicleName = ''
      this.newVehicleLicensePlateNo = ''
    },
    // this.articleNoFilter comes from the selected Vehicles or Agreement DetailValidArticles when Valid Choice is installed and some few Articles are selected on the Vehicle/Agreement,
    // else null that will return all (non-deleted) Articles
    async loadFilteredArticles () {
      const res = await ScanMobile.loadFilteredArticles({ facilityNo: this.form.facilityNo, ArticleNoFilter: this.articleNoFilter })
      if (!res.failed) {
        this.form.articles = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '), // https://stackoverflow.com/a/19903063
            value: item.No,
            obj: item
          }
        })
      }
    },
    async loadFilteredArticlesT () {
      const res = await ScanMobile.loadFilteredArticles({ facilityNo: this.form.facilityNo, ArticleNoFilter: this.articleNoFilterT })
      if (!res.failed) {
        this.formT.articles = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '), // https://stackoverflow.com/a/19903063
            value: item.No,
            obj: item
          }
        })
      }
    },
    async loadAgreement (number) {
      const res = await Archive.loadAgreement({ facilityNo: this.form.facilityNo, no: number, searchCriteria: null, top: this.form.top, agreementNoFilter: this.agreementNoFilter })
      if (!res.failed) {
        this.form.agreements = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }
    },
    async loadAgreementT (number) {
      const res = await Archive.loadAgreement({ facilityNo: this.form.facilityNo, no: number, searchCriteria: null, top: this.formT.top, agreementNoFilter: this.agreementNoFilterT })
      if (!res.failed) {
        this.formT.agreements = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }
    },
    async updateUi () {
      this.form.facilities = [this.$t('Loading ...')]
      this.form.facilitiesDescription = [this.$t('Loading ...')]
      this.form.agreements = [this.$t('Loading ...')]
      this.form.deliveries = [this.$t('Loading ...')]
      this.form.customers = [this.$t('Loading ...')]
      this.form.articles = [this.$t('Loading ...')]
      this.form.carriers = [this.$t('Loading ...')]
      this.form.plants = [this.$t('Loading ...')]
      this.form.storages = [this.$t('Loading ...')]

      let res = await Archive.loadFacilities(true)
      const facilitiesResDescription = _.cloneDeep(res)
      if (!res.failed) {
        const noGlobal = res.data.filter(o => o.No !== '')
        this.form.facilities = noGlobal.map(item => {
          return {
            text: item.No,
            value: item.No,
            obj: item
          }
        })

        let skipLoadFacility = false
        if (this.facilityNo == null || this.facilityNo === 'null' || this.facilityNo === undefined) {
          // this.facilityNo = this.form.facilityNo
          skipLoadFacility = true
        }

        if (!skipLoadFacility) {
          const fac = await ScanMobile.loadFacilityData({ facilityNo: this.facilityNo, corpName: Security.user.corporation })
          if (!fac.failed) {
            const showUpD = this.details.find(o => o.Name === 'newRegUpBtn')
            if (showUpD !== undefined) {
              this.showUp = showUpD.Value
            }
            const showDwnD = this.details.find(o => o.Name === 'newRegDownBtn')
            if (showDwnD !== undefined) {
              this.showDown = showDwnD.Value
            }
          }
        }

        this.form.facilitiesDisplay = this.form.facilities
        if (this.useFacilityDescription) {
          var d = facilitiesResDescription.data
          if (!d.includes('')) d.unshift({ No: '', Description: '' })
          const noGlobal2 = d.filter(o => o.No !== '')
          this.form.facilitiesDescription = noGlobal2.map(item => {
            return {
              text: item.Description,
              value: item.Description,
              item: item
            }
          })
          this.form.facilitiesDisplay = this.form.facilitiesDescription
        }

        if (this.useFacilityDescription) {
          if (this.form.facilitiesDescription.length > 0) {
            if (this.form.facilityNo === null || this.form.facilityNo === 'null') {
              this.form.facilityDisplay = ''
            } else {
              this.form.facilityDisplay = this.form.facilitiesDescription.find(f => f.item.No === this.form.facilityNo).value
            }
          }
        }
      }
      res = await Archive.loadCarriers(this.form.facilityNo)
      if (!res.failed) {
        this.form.carriers = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }

      res = await Archive.loadStorages(this.form.facilityNo)
      if (!res.failed) {
        this.form.storages = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }

      res = await Archive.loadPlants(this.form.facilityNo)
      if (!res.failed) {
        this.form.plants = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }

      this.form.searchCriteria = this.form.customerNo
      res = await Archive.loadCustomers({ facilityNo: this.form.facilityNo, searchCriteria: this.form.searchCriteria, top: this.form.top })
      if (!res.failed) {
        this.form.customers = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }

      // Load Filtered Articles via Vehicle ValidArticles
      this.loadFilteredArticles()

      // Load only agreementNo into list
      this.form.searchCriteria = this.form.agreementNo
      res = await Archive.loadAgreement({ facilityNo: this.form.facilityNo, no: this.form.agreementNo, searchCriteria: null, top: this.form.top, agreementNoFilter: this.agreementNoFilter })
      if (!res.failed) {
        this.form.agreements = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }

      this.updateDeliveries()

      // Force validation of all fields to show requrired
      if (this.$refs.form && !this.$refs.form.validate()) this.valid = false

      if (this.transferRegistration) {
        this.updateUiT()
      }

      this.$forceUpdate()
    },
    async updateUiT () {
      this.formT.facilities = [this.$t('Loading ...')]
      this.formT.facilitiesDisplay = [this.$t('Loading ...')]
      this.formT.agreements = [this.$t('Loading ...')]
      this.formT.deliveries = [this.$t('Loading ...')]
      this.formT.customers = [this.$t('Loading ...')]
      this.formT.articles = [this.$t('Loading ...')]
      this.formT.carriers = [this.$t('Loading ...')]
      this.formT.plants = [this.$t('Loading ...')]
      this.formT.storages = [this.$t('Loading ...')]

      let res = await Archive.loadFacilities(true)
      const facilitiesResDescription = _.cloneDeep(res)
      if (!res.failed) {
        const noGlobal = res.data.filter(o => o.No !== '')
        this.formT.facilities = noGlobal.map(item => {
          return {
            text: item.No,
            value: item.No,
            obj: item
          }
        })
        this.formT.facilitiesDisplay = this.formT.facilities
        if (this.useFacilityDescription) {
          var d = facilitiesResDescription.data
          if (!d.includes('')) d.unshift({ No: '', Description: '' })
          this.formT.facilitiesDescription = d.map(item => {
            return {
              text: item.Description,
              value: item.Description,
              item: item
            }
          })
          this.formT.facilitiesDisplay = this.formT.facilitiesDescription
        }
      }

      res = await Archive.loadCarriers(this.form.facilityNo)
      if (!res.failed) {
        this.formT.carriers = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }

      res = await Archive.loadStorages(this.form.facilityNo)
      if (!res.failed) {
        this.formT.storages = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }

      res = await Archive.loadPlants(this.form.facilityNo)
      if (!res.failed) {
        this.formT.plants = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }

      this.formT.searchCriteria = this.formT.customerNo
      res = await Archive.loadCustomers({ facilityNo: this.form.facilityNo, searchCriteria: this.formT.searchCriteria, top: this.formT.top })
      if (!res.failed) {
        this.formT.customers = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }

      // Load Filtered Articles via Vehicle ValidArticles
      this.loadFilteredArticlesT()

      // Load only agreementNo into list
      this.formT.searchCriteria = this.formT.agreementNo
      res = await Archive.loadAgreement({ facilityNo: this.form.facilityNo, no: this.formT.agreementNo, searchCriteria: null, top: this.formT.top, agreementNoFilter: this.agreementNoFilterT })
      if (!res.failed) {
        this.formT.agreements = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }

      this.updateDeliveriesT()

      // Force validation of all fields to show requrired
      if (this.$refs.form && !this.$refs.form.validate()) this.valid = false

      // this.$forceUpdate()
    },
    async updateDeliveries () {
      const res = await Archive.loadDeliveries({ facilityNo: this.form.facilityNo, agreementId: this.getItemFromArray(this.form.agreements, this.form.agreementNo, 'Id') })
      if (!res.failed) {
        this.form.deliveries = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
        // Clear old value if not in new deliveries
        if (!this.form.deliveries.find(d => d.value === this.form.deliveryNo)) this.form.deliveryNo = ''
      }
    },
    async updateDeliveriesT () {
      const res = await Archive.loadDeliveries({ facilityNo: this.form.facilityNo, agreementId: this.getItemFromArray(this.formT.agreements, this.formT.agreementNo, 'Id') })
      if (!res.failed) {
        this.formT.deliveries = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
        // Clear old value if not in new deliveries
        if (!this.formT.deliveries.find(d => d.value === this.formT.deliveryNo)) this.formT.deliveryNo = ''
      }
    },
    async facilityChanged () {
      if (this.useFacilityDescription) {
        var facilityDisplay = this.form.facilitiesDisplay.find(f => f.value === this.form.facilityDisplay)
        if (facilityDisplay != null) {
          this.form.facilityNo = facilityDisplay.item.No
        }
        if (this.transferRegistration) {
          facilityDisplay = this.formT.facilitiesDisplay.find(f => f.value === this.formT.facilityDisplay)
          if (facilityDisplay != null) {
            this.formT.facilityNo = facilityDisplay.item.No
          }
        }
      } else {
        this.form.facilityNo = this.form.facilityDisplay
        if (this.transferRegistration) {
          this.formT.facilityNo = this.form.facilityDisplay
        }
      }

      this.preventLeave = false
      if (this.form.facilityNo != null) LocalStorage.save('facilityNo', this.form.facilityNo)
      this.form.vehicleNo = ''
      this.form.requisitionNo1 = ''
      this.form.requisitionNo2 = ''
      this.form.plantNo = ''
      this.form.carrierNo = ''
      this.form.articleNo = ''
      this.form.customerNo = ''
      this.form.agreementNo = ''
      this.form.deliveryNo = ''
      this.form.storage1 = ''
      this.form.storage2 = ''

      if (this.transferRegistration) {
        this.formT.requisitionNo1 = ''
        this.formT.requisitionNo2 = ''
        this.formT.plantNo = ''
        this.formT.carrierNo = ''
        this.formT.articleNo = ''
        this.formT.customerNo = ''
        this.formT.agreementNo = ''
        this.formT.deliveryNo = ''
        this.formT.storage1 = ''
        this.formT.storage2 = ''
      }

      this.manualIndicator = false
      // console.log('pip', this.manualIndicator)
      const res = await ScanMobile.getCurrentWeightIds(this.form.facilityNo)
      if (!res.failed && res.data.length) {
        this.VT25List = res.data
        this.VT25List.unshift(['Manual'])// this.$t('Manual')])
        if (this.selectedVT25 === 'Manual') { // this.$t('Manual')) {
          this.selectedVT25 = this.VT25List[0]
          this.manualIndicator = true
          this.displayWeight = 0
        }
      } else {
        this.VT25List = ['Manual']// this.$t(['Manual'])
        this.selectedVT25 = this.VT25List[0]
        this.manualIndicator = true
        this.displayWeight = 0
      }
      // console.log('pip2', this.manualIndicator)

      if (this.userVehicleNo.toString() !== '') {
        this.form.vehicleNo = this.userVehicleNo.toString()
        this.vehicleChanged()
      }
      // this.updateUi()
    },
    async deliveryChanged () {
      this.preventLeave = false
      var requisitionNo1 = this.getValueFromArray(this.getItemFromArray(this.form.deliveries, this.form.deliveryNo, 'Details'), 'DelRequisitionNo')
      var requisitionNo2 = this.getValueFromArray(this.getItemFromArray(this.form.deliveries, this.form.deliveryNo, 'Details'), 'DelRequisitionNo2')
      var plantNo = this.getValueFromArray(this.getItemFromArray(this.form.deliveries, this.form.deliveryNo, 'Details'), 'DelPlantNo')
      var carrierNo = this.getValueFromArray(this.getItemFromArray(this.form.deliveries, this.form.deliveryNo, 'Details'), 'DelCarrierNo')
      var articleNo = this.getValueFromArray(this.getItemFromArray(this.form.deliveries, this.form.deliveryNo, 'Details'), 'DelArticleNo')
      var customerNo = this.getValueFromArray(this.getItemFromArray(this.form.deliveries, this.form.deliveryNo, 'Details'), 'DelCustomerNo')

      if (requisitionNo1) this.form.requisitionNo1 = requisitionNo1
      if (requisitionNo2) this.form.requisitionNo2 = requisitionNo2
      if (plantNo) this.form.plantNo = plantNo
      if (carrierNo) this.form.carrierNo = carrierNo
      if (articleNo) { this.form.articleNo = articleNo; this.articleChanged() }
      if (customerNo) { this.form.customerNo = customerNo; this.updateCustomers(customerNo) }

      this.$forceUpdate()
    },
    async deliveryChangedT () {
      this.preventLeave = false
      var requisitionNo1 = this.getValueFromArray(this.getItemFromArray(this.formT.deliveries, this.formT.deliveryNo, 'Details'), 'DelRequisitionNo')
      var requisitionNo2 = this.getValueFromArray(this.getItemFromArray(this.formT.deliveries, this.formT.deliveryNo, 'Details'), 'DelRequisitionNo2')
      var plantNo = this.getValueFromArray(this.getItemFromArray(this.formT.deliveries, this.formT.deliveryNo, 'Details'), 'DelPlantNo')
      var carrierNo = this.getValueFromArray(this.getItemFromArray(this.formT.deliveries, this.formT.deliveryNo, 'Details'), 'DelCarrierNo')
      var articleNo = this.getValueFromArray(this.getItemFromArray(this.formT.deliveries, this.formT.deliveryNo, 'Details'), 'DelArticleNo')
      var customerNo = this.getValueFromArray(this.getItemFromArray(this.formT.deliveries, this.formT.deliveryNo, 'Details'), 'DelCustomerNo')

      if (requisitionNo1) this.formT.requisitionNo1 = requisitionNo1
      if (requisitionNo2) this.formT.requisitionNo2 = requisitionNo2
      if (plantNo) this.formT.plantNo = plantNo
      if (carrierNo) this.formT.carrierNo = carrierNo
      if (articleNo) { this.formT.articleNo = articleNo; this.articleChangedT() }
      if (customerNo) { this.formT.customerNo = customerNo; this.updateCustomersT(customerNo) }

      this.$forceUpdate()
    },
    async agreementChanged () {
      this.preventLeave = false
      this.form.deliveries = [this.$t('Loading ...')]
      this.form.deliveryNo = ''
      var requisitionNo1 = this.getValueFromArray(this.getItemFromArray(this.form.agreements, this.form.agreementNo, 'Details'), 'RequisitionNo')
      var requisitionNo2 = this.getValueFromArray(this.getItemFromArray(this.form.agreements, this.form.agreementNo, 'Details'), 'RequisitionNo2')

      var plantNo = this.getValueFromArray(this.getItemFromArray(this.form.agreements, this.form.agreementNo, 'Details'), 'PlantNo')
      var carrierNo = this.getValueFromArray(this.getItemFromArray(this.form.agreements, this.form.agreementNo, 'Details'), 'CarrierNo')
      var articleNo = this.getValueFromArray(this.getItemFromArray(this.form.agreements, this.form.agreementNo, 'Details'), 'ArticleNo')
      var customerNo = this.getValueFromArray(this.getItemFromArray(this.form.agreements, this.form.agreementNo, 'Details'), 'CustomerNo')

      this.articleNoFilter = this.getData1FromArray(this.getItemFromArray(this.form.agreements, this.form.agreementNo, 'Details'), 'ValidArticles')

      if (requisitionNo1) this.form.requisitionNo1 = requisitionNo1
      if (requisitionNo2) this.form.requisitionNo2 = requisitionNo2
      if (plantNo) this.form.plantNo = plantNo
      if (carrierNo) this.form.carrierNo = carrierNo
      if (articleNo) { this.form.articleNo = articleNo; this.articleChanged() }
      if (customerNo) { this.form.customerNo = customerNo; this.updateCustomers(customerNo) }

      this.updateDeliveries()
      this.loadFilteredArticles()
      this.$forceUpdate()
    },
    async agreementChangedT () {
      this.preventLeave = false
      this.formT.deliveries = [this.$t('Loading ...')]
      this.formT.deliveryNo = ''
      var requisitionNo1 = this.getValueFromArray(this.getItemFromArray(this.formT.agreements, this.formT.agreementNo, 'Details'), 'RequisitionNo')
      var requisitionNo2 = this.getValueFromArray(this.getItemFromArray(this.formT.agreements, this.formT.agreementNo, 'Details'), 'RequisitionNo2')

      var plantNo = this.getValueFromArray(this.getItemFromArray(this.formT.agreements, this.formT.agreementNo, 'Details'), 'PlantNo')
      var carrierNo = this.getValueFromArray(this.getItemFromArray(this.formT.agreements, this.formT.agreementNo, 'Details'), 'CarrierNo')
      var articleNo = this.getValueFromArray(this.getItemFromArray(this.formT.agreements, this.formT.agreementNo, 'Details'), 'ArticleNo')
      var customerNo = this.getValueFromArray(this.getItemFromArray(this.formT.agreements, this.formT.agreementNo, 'Details'), 'CustomerNo')

      this.articleNoFilterT = this.getData1FromArray(this.getItemFromArray(this.formT.agreements, this.formT.agreementNo, 'Details'), 'ValidArticles')

      if (requisitionNo1) this.formT.requisitionNo1 = requisitionNo1
      if (requisitionNo2) this.formT.requisitionNo2 = requisitionNo2
      if (plantNo) this.formT.plantNo = plantNo
      if (carrierNo) this.formT.carrierNo = carrierNo
      if (articleNo) { this.formT.articleNo = articleNo; this.articleChangedT() }
      if (customerNo) { this.formT.customerNo = customerNo; this.updateCustomersT(customerNo) }

      this.updateDeliveriesT()
      this.loadFilteredArticlesT()
      this.$forceUpdate()
    },
    async vehicleChanged (doNotLoadAgreement = false) {
      // Fix selecting "Search" by accident
      if ((!this.form.vehicleNo && this.form.vehicles.length !== 1) || (this.form.vehicleNo && this.form.vehicleNo.includes(this.$t('Search')))) {
        this.form.vehicles = []
        this.form.vehicleNo = ''
        this.searchVehicle = ''
      }

      this.preventLeave = false
      this.form.requisitionNo1 = ''
      this.form.requisitionNo2 = ''
      this.form.plantNo = ''
      this.form.carrierNo = ''
      this.form.articleNo = ''
      this.form.customerNo = ''
      this.form.agreementNo = ''
      this.form.deliveryNo = ''

      var requisitionNo1 = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'RequisitionNo')
      var requisitionNo2 = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'RequisitionNo2')
      var plantNo = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'PlantNo')
      var carrierNo = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'CarrierNo')
      var articleNo = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'ArticleNo')
      var customerNo = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'CustomerNo')
      var deliveryNo = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'DeliveryNo')
      var agreementNo = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'AgreementNo')

      var last = this.agreementNoFilter
      var last2 = this.articleNoFilter
      this.articleNoFilter = this.getData1FromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'ValidArticles')
      this.agreementNoFilter = this.getData1FromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'ValidAgreements')
      var changed = false
      if ((last !== this.agreementNoFilter) || (last2 !== this.articleNoFilter)) {
        changed = true
      }

      await this.handleSingleTareNo()
      if (requisitionNo1) this.form.requisitionNo1 = requisitionNo1
      if (requisitionNo2) this.form.requisitionNo2 = requisitionNo2
      if (plantNo) this.form.plantNo = plantNo
      if (carrierNo) this.form.carrierNo = carrierNo
      if (articleNo) {
        this.form.articleNo = articleNo; this.articleChanged()
      } else {
        // Load current (stored) ArticleNo - ONLY if no article on vehicle
        /* const currentRegArticleNo = LocalStorage.load('currentRegArticleNo')
        if (currentRegArticleNo) {
          this.form.articleNo = currentRegArticleNo.toString()
        } else { LocalStorage.remove('currentRegArticleNo') } */
      }

      if (customerNo) { this.form.customerNo = customerNo; this.updateCustomers(customerNo) }
      if (agreementNo) { this.form.agreementNo = agreementNo; this.agreementChanged() }
      if (deliveryNo) { this.form.deliveryNo = deliveryNo; this.deliveryChanged() }

      this.loadFilteredArticles()
      if (!doNotLoadAgreement) {
        this.loadAgreement(this.form.agreementNo)
      }

      if (this.scanMobileSaved) {
        this.loadVehicleHistory()
      }

      if (this.transferRegistration) {
        this.preventLeave = false
        this.formT.requisitionNo1 = ''
        this.formT.requisitionNo2 = ''
        this.formT.plantNo = ''
        this.formT.carrierNo = ''
        this.formT.articleNo = ''
        this.formT.customerNo = ''
        this.formT.agreementNo = ''
        this.formT.deliveryNo = ''

        var requisitionNo1T = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'RequisitionNo')
        var requisitionNo2T = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'RequisitionNo2')
        var plantNoT = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'PlantNo')
        var carrierNoT = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'CarrierNo')
        var articleNoT = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'ArticleNo')
        var customerNoT = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'CustomerNo')
        var deliveryNoT = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'DeliveryNo')
        var agreementNoT = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'AgreementNo')

        this.articleNoFilterT = this.getData1FromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'ValidArticles')
        this.agreementNoFilterT = this.getData1FromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'ValidAgreements')
        await this.handleSingleTareNo()
        if (requisitionNo1T) this.formT.requisitionNo1 = requisitionNo1T
        if (requisitionNo2T) this.formT.requisitionNo2 = requisitionNo2T
        if (plantNoT) this.formT.plantNo = plantNoT
        if (carrierNoT) this.formT.carrierNo = carrierNoT
        if (articleNoT) {
          this.formT.articleNo = articleNoT; this.articleChangedT()
        } else {
          // Load current (stored) ArticleNo - ONLY if no article on vehicle
          /* const currentRegArticleNo = LocalStorage.load('currentRegArticleNo')
          if (currentRegArticleNo) {
            this.form.articleNo = currentRegArticleNo.toString()
          } else { LocalStorage.remove('currentRegArticleNo') } */
        }

        if (customerNoT) { this.formT.customerNo = customerNoT; this.updateCustomersT(customerNoT) }
        if (agreementNoT) { this.formT.agreementNo = agreementNoT; this.agreementChangedT() }
        if (deliveryNoT) { this.formT.deliveryNo = deliveryNoT; this.deliveryChangedT() }

        this.loadFilteredArticlesT()
        this.loadAgreementT(this.formT.agreementNo)
      }

      if (changed) {
        this.updateUi()
      }

      this.$forceUpdate()
      LocalStorage.save('currentRegVehicleNo', this.form.vehicleNo)
    },
    async articleChanged () {
      this.preventLeave = false
      var plantNo = this.getValueFromArray(this.getItemFromArray(this.form.articles, this.form.articleNo, 'Details'), 'PlantNo')
      if (plantNo) this.form.plantNo = plantNo
      this.$forceUpdate()
      LocalStorage.save('currentRegArticleNo', this.form.articleNo)
    },
    async articleChangedT () {
      this.preventLeave = false
      var plantNo = this.getValueFromArray(this.getItemFromArray(this.formT.articles, this.formT.articleNo, 'Details'), 'PlantNo')
      if (plantNo) this.formT.plantNo = plantNo
      this.$forceUpdate()
      // LocalStorage.save('currentRegArticleNo', this.formT.articleNo)
    },
    async loadVehicleHistory () {
      const res = await ScanMobile.loadRegistrationHistory({ Facility: this.form.facilityNo, VehicleNo: this.form.vehicleNo })
      if (!res.failed) {
        this.ObjectToform(res.data)
      }
    },
    async tst () {
      // this.$root.$message.showSuccess(this.$t("tst:"+this.form.article))
      /* console.log('---->> this.form.vehicleNo:', this.form.vehicleNo, this.form.articleNo)
      console.log('---->> LicensePlateNo:', this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'LicensePlateNo'))
      console.log('---->> Name:', this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Name'))
      console.log('---->> Art:', this.getItemFromArray(this.form.articles, this.form.articleNo, 'Name'))
      console.log('---->> Lists:', this.form.articles, this.form.vehicles) */
    },
    getItemFromArray (array, findNo, findPropertyName) {
      var result = null
      if (Array.isArray(array) && array.length) {
        // array exists and is not empty
        var found = array.find(o => o.obj?.No === findNo)
        if (found) {
          // item exists
          result = found.obj[findPropertyName]
          // if property does not exist we return null
          if (result === undefined) result = null
        }
      }
      return result
    },
    getValueFromArray (array, findName) {
      var result = null
      if (Array.isArray(array) && array.length) {
        // array exists and is not empty
        var found = array.find(o => o.Name === findName)
        if (found) {
          // item exists
          result = found.Value
          // if property does not exist we return null
          if (result === undefined) result = null
        }
      }
      return result
    },
    getData1FromArray (array, findName) {
      var result = null
      if (Array.isArray(array) && array.length) {
        // array exists and is not empty
        var found = array.find(o => o.Name === findName)
        if (found) {
          // item exists
          result = found.Data1
          // if property does not exist we return null
          if (result === undefined) result = null
        }
      }
      return result
    },
    isHide (fieldName) {
      return this.hiddenFields.some(h => h === fieldName)
    },
    isHideT (fieldName) {
      if (!this.transferRegistration) {
        return true
      }
      return this.hiddenFields.some(h => h === fieldName)
    },
    isReadonly (fieldName) {
      if (this.userVehicleNo !== '' && fieldName === 'Vehicle') {
        return true
      }
      return this.readonlyFields.some(h => h === fieldName)
    },
    isRequired (fieldName) {
      if (fieldName === 'Article' && this.transferRegistration) {
        // console.log('pip', this.requiredFields, fieldName, this.requiredFields.some(h => h === fieldName), rules)
      }
      return this.requiredFields.some(h => h === fieldName)
    },
    async finishRegistration (id) {
      const res0 = await ScanMobile.loadRegistration(id)
      if (!res0.failed) {
        if (res0.data != null) {
          this.smReg.Registration = res0.data.Registration
          this.smReg.id = id
          this.smReg.registrationId = this.smReg.Registration.Id
          this.smReg.facilityNo = this.facilityNo
          this.smReg.comment = this.smReg.Registration.Comment1
        }
        if (this.tareVehicle) {
          this.smReg.Registration.WeightFirst = this.weightSecond
        }
        if (this.tareValue > 0) {
          this.smReg.Registration.WeightFirst = this.tareValue
        }
        if (this.smReg.Registration.Facility === undefined) {
          this.smReg.Registration.Facility = this.smReg.facilityNo
        }
        if (this.smReg.facilityNo === undefined) {
          this.smReg.facilityNo = this.smReg.Registration.Facility
        }
        if (res0.data != null) {
          this.smReg.Facility = res0.data.Facility
        }
        // Grab an update of the reg to get ScanXRegNo etc.
        var res1 = await Archive.loadVehicle({ facilityNo: this.smReg.Registration.Facility, vehicleNo: this.smReg.Registration.VehicleNo })
        if (!res1.failed) {
          this.smReg.TareWeight = Math.round(res1.data.Details.find(o => o.Name === 'TareWeight')?.Value ?? 0)
          this.TareWeight = this.smReg.TareWeight
          if (this.smReg.TareWeight > 0) {
            this.smReg.Registration.WeightFirst = this.smReg.TareWeight
            this.smReg.TareWeight = this.weightSecond
          }
        }

        if (this.tempTareSet) {
          if (this.tempTareValue.Value === undefined) {
            this.smReg.Registration.WeightFirst = this.tempTareValue
          } else {
            this.smReg.Registration.WeightFirst = this.tempTareValue.Value
          }
          this.smReg.TareWeight = this.weightSecond
          this.smReg.Registration.WeightSecond = this.weightSecond
          if (this.tempTareSet) {
            if (this.smReg.Registration.WeightSecond === 0) {
              this.$root.$message.showError(this.$t('Invalid weight. Please fix and retry') + ' (0 kg)')
              return
            }
          }
        }
        // Tare calulation for ScanMobile ONLY on Finish reg (Also in Weight.vue)
        this.smReg.Registration.DateFirst = new Date()
        this.smReg.Registration.WeightSecond = this.smReg.TareWeight
        this.smReg.Registration.DateSecond = new Date()
        this.smReg.Registration.WeightNet = this.smReg.Registration.WeightFirst - this.smReg.Registration.WeightSecond
        this.WeightNet = this.smReg.Registration.WeightNet
        if (this.secondRegistration) {
          this.smReg.Registration.WeightSecond = this.weightSecond
          this.smReg.Registration.WeightNet = this.smReg.Registration.WeightFirst - this.smReg.Registration.WeightSecond
        }
      }
      this.submitting = true

      if (this.transferRegistration && (this.tareVehicle || this.tempTareValue != null)) {
        this.formToObjectT()
      }
      const res2 = await ScanMobile.saveRegistration({
        Id: this.smReg.id,
        RegistrationId: this.smReg.registrationId,
        Facility: this.smReg.facilityNo,
        FinishedDate: new Date(),
        FinishedBy: this.smReg.finishedBy,
        Comment: this.smReg.comment,
        Registration: this.smReg.Registration,
        TransferRegistration: this.smReg.RegistrationT,
        Storage1: this.smReg.Storage1,
        Storage2: this.smReg.Storage2,
        StorageT1: this.smReg.StorageT1,
        StorageT2: this.smReg.StorageT2
      })

      this.submitting = false
      if (!res2.failed) {
        this.$root.$message.showSuccess(this.$t('Registration finished'))
        // Re-Load registrations
        this.preventLeave = false
        this.$router.push({ name: this.redirectTo })
        this.loadScanMobileRegistrations()
      }
    },
    saveVT25 () {
      this.manualIndicator = false
      // console.log('pip3', this.manualIndicator)
      this.activeVT25 = this.selectedVT25
      if (this.selectedVT25[0] === 'Manual' /* this.$t('Manual') */) {
        this.manualIndicator = true
        this.displayWeight = 0
      }
      LocalStorage.save('activeScanMobileIndicator', this.activeVT25)
      // console.log('pip4', this.manualIndicator)
    },
    async formToObject () {
      this.smReg.facilityNo = this.form.facilityNo

      if (!this.smReg.Registration) this.smReg.Registration = {}

      this.smReg.Registration.VehicleNo = this.form.vehicleNo
      this.smReg.Registration.VehicleName = this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Name')
      this.smReg.Registration.VehicleLicensePlateNo = this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'LicensePlateNo')
      this.smReg.Registration.AgreementNo = this.form.agreementNo
      this.smReg.Registration.AgreementName = this.getItemFromArray(this.form.agreements, this.form.agreementNo, 'Name')
      this.smReg.Registration.DeliveryNo = this.form.deliveryNo
      this.smReg.Registration.DeliveryName = this.getItemFromArray(this.form.deliveries, this.form.deliveryNo, 'Name')
      this.smReg.Registration.CustomerNo = this.form.customerNo
      this.smReg.Registration.CustomerName = this.getItemFromArray(this.form.customers, this.form.customerNo, 'Name')
      this.smReg.Registration.ArticleNo = this.form.articleNo
      this.smReg.Registration.ArticleName = this.getItemFromArray(this.form.articles, this.form.articleNo, 'Name')
      this.smReg.Registration.PlantNo = this.form.plantNo
      this.smReg.Registration.PlantName = this.getItemFromArray(this.form.plants, this.form.plantNo, 'Name')
      this.smReg.Registration.CarrierNo = this.form.carrierNo
      this.smReg.Registration.CarrierName = this.getItemFromArray(this.form.carriers, this.form.carrierNo, 'Name')
      this.smReg.Registration.RequisitionNo1 = this.form.requisitionNo1
      this.smReg.Registration.RequisitionNo2 = this.form.requisitionNo2
      this.smReg.Registration.Comment1 = this.form.comment1
      this.smReg.Registration.DateFirst = new Date()
      this.smReg.Registration.WeightFirst = this.weightFirst
      this.smReg.Registration.WeightSecond = this.weightSecond
      this.smReg.Storage1 = this.form.storage1
      this.smReg.Storage2 = this.form.storage2
    },
    async formToObjectT () {
      if (!this.smReg.RegistrationT) this.smReg.RegistrationT = {}
      this.smReg.RegistrationT.AgreementNo = this.formT.agreementNo
      this.smReg.RegistrationT.DeliveryNo = this.formT.deliveryNo
      this.smReg.RegistrationT.CustomerNo = this.formT.customerNo
      this.smReg.RegistrationT.ArticleNo = this.formT.articleNo
      this.smReg.RegistrationT.PlantNo = this.formT.plantNo
      this.smReg.RegistrationT.CarrierNo = this.formT.carrierNo
      this.smReg.RegistrationT.RequisitionNo1 = this.formT.requisitionNo1
      this.smReg.RegistrationT.RequisitionNo2 = this.formT.requisitionNo2
      this.smReg.RegistrationT.Comment1 = this.formT.comment1
      this.smReg.RegistrationT.WeightFirst = this.weightFirst
      this.smReg.RegistrationT.WeightSecond = this.weightSecond
      this.smReg.StorageT1 = this.formT.storage1
      this.smReg.StorageT2 = this.formT.storage2
    },
    ObjectToform (val) {
      this.form.agreementNo = val.Registration.AgreementNo
      this.form.deliveryNo = val.Registration.DeliveryNo
      this.form.customerNo = val.Registration.CustomerNo
      this.form.articleNo = val.Registration.ArticleNo
      this.form.plantNo = val.Registration.PlantNo
      this.form.carrierNo = val.Registration.CarrierNo
      this.form.requisitionNo1 = val.Registration.RequisitionNo1
      this.form.requisitionNo2 = val.Registration.RequisitionNo2
      this.form.comment1 = val.Registration.Comment1
      this.form.storage1 = val.Storage1
      this.form.storage2 = val.Storage2
      this.$forceUpdate()
    },
    async saveReg (val) {
      // Pending Vehicle check to avoid Import/Export problems and because ScanX only supports ONE Vehicle pr. 1. weighing.
      if (this.$route.params.pendingVehicles !== undefined && this.$route.params.pendingVehicles.length && this.$route.params.pendingVehicles.some(p => p === this.form.vehicleNo)) {
        this.$root.$message.showError(this.$t('Vehicle') + ' ' + this.form.vehicleNo.toString() + ' ' + this.$t('has an unfinished registration. Please Finish or use another.'))
      } else {
        this.preventLeave = false
        if (this.$refs.form.validate()) {
          this.saving = true
          this.formToObject()
          if (this.transferRegistration) {
            this.formToObjectT()
          }
          const res = await ScanMobile.saveRegistration({
            Id: this.smReg.id,
            RegistrationId: this.smReg.registrationId,
            Facility: this.smReg.facilityNo,
            FinishedDate: this.smReg.finishedDate,
            FinishedBy: this.smReg.finishedBy,
            Comment: this.smReg.comment,
            Registration: this.smReg.Registration,
            RegistrationType: 0, // 0 = Registration
            TransferRegistration: this.smReg.RegistrationT,
            Storage1: this.smReg.Storage1,
            Storage2: this.smReg.Storage2,
            StorageT1: this.smReg.StorageT1,
            StorageT2: this.smReg.StorageT2
          })
          if (!res.failed) {
            this.smReg.Id = res.data.Id
            this.smReg.finishedDate = res.data.Registration.DateSecond
            this.smReg.Registration.Id = res.data.Id
          } else {
            return
          }

          this.saving = false
          this.$root.$message.showSuccess(this.$t('Saved'))
          this.preventLeave = false

          // After Save, jump back to Registrations or directly to Set Weight
          if (val === 'gotoSetWeight') {
            this.$router.push({ name: this.redirectToSetWeight, params: { id: this.smReg.id, reg: this.smReg, edit: this.showSaveButton } })
          } else { // gotoRegistrations
            this.$router.push({ name: this.redirectTo })
          }
        }
      }
    },
    async save (val) {
      const res = await this.ValidateRequiredField()
      if (!res) {
        this.$root.$message.showError(this.$t('Please add required fields'))
        return
      }

      // Pending Vehicle check to avoid Import/Export problems and because ScanX only supports ONE Vehicle pr. 1. weighing.
      if (this.$route.params.pendingVehicles !== undefined && this.$route.params.pendingVehicles.length && this.$route.params.pendingVehicles.some(p => p === this.form.vehicleNo)) {
        this.$root.$message.showError(this.$t('Vehicle') + ' ' + this.form.vehicleNo.toString() + ' ' + this.$t('has an unfinished registration. Please Finish or use another.'))
      } else {
        this.preventLeave = false
        if (this.$refs.form.validate()) {
          this.saving = true
          this.formToObject()
          this.saving = false
          this.preventLeave = false

          // After Save, jump back to Registrations or directly to Set Weight
          if (val === 'gotoSetWeight') {
            if (this.transferRegistration) {
              this.formToObjectT()
            }
            this.$router.push({ name: this.redirectToSetWeight, params: { id: this.smReg.id, reg: this.smReg, edit: this.showSaveButton, transferRegistration: this.smReg.RegistrationT, s1: this.form.storage1, s2: this.form.storage2, st1: this.formT.storage1, st2: this.formT.storage2 } })
          } else { // gotoRegistrations
            this.$router.push({ name: this.redirectTo })
          }
        }
      }
    }
  },
  watch: {
  },
  beforeDestroy () {
    // Stop live poll VT25/WK60 getWeight
    this.stopWeightTimer()
  },
  async mounted () {
    if (this.$route.params.pendingVehicles === undefined) {
      // Go back to Registrations
      this.$router.push({ name: this.redirectTo })
    }

    if (this.$route.params.storage !== undefined) {
      this.storageNo = this.$route.params.storage
    }

    if (this.$route.params.facility !== undefined) {
      // Go back to Registrations
      this.form.facilityNo = '' + this.$route.params.facility
    }

    // We use next tick to ensure that app is initialized
    this.$nextTick(() => {
      app.$on('force-update', () => {
        // We need this to ensure that autoLogin re-renders component
        this.$forceUpdate()
      })
    })

    this.scanMobileSaved = LocalStorage.load('RecallData')
    const vt25 = LocalStorage.load('activeScanMobileIndicator')
    if (vt25) { this.activeVT25 = vt25 } else { LocalStorage.remove('activeScanMobileIndicator') }

    const transfer = LocalStorage.load('transferRegistration')
    if (transfer) { this.transferRegistration = transfer } else { LocalStorage.remove('transferRegistration') }

    this.selectedVT25 = this.activeVT25
    const res = await ScanMobile.getCurrentWeightIds(this.form.facilityNo)
    if (!res.failed && res.data.length) {
      this.VT25List = res.data
      this.VT25List.unshift(['Manual'])// this.$t('Manual')])
      if (this.selectedVT25 === 'Manual') { // this.$t('Manual')) {
        this.selectedVT25 = this.VT25List[0]
        this.manualIndicator = true
        this.displayWeight = 0
      }
    } else {
      this.VT25List = ['Manual']// this.$t(['Manual'])
      this.selectedVT25 = this.VT25List[0]
      this.manualIndicator = true
      this.displayWeight = 0
    }
    // Use Settings from cached user's corporatationDetails
    if (Security.user.corporationDetails) {
      const defaultHidden = 'RequisitionNo2,Plant,Carrier,Comment' // New fields default hidden LSV/MITH. Remember to also add new defaults in Settings.vue and Registrations.vue
      this.hiddenFields = (Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_Fields_Hidden')?.Data1 ?? defaultHidden).split(',')
      this.readonlyFields = (Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_Fields_ReadOnly')?.Data1 ?? '').split(',')
      this.requiredFields = (Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_Fields_Mandatory')?.Data1 ?? '').split(',')
      if (Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_Disable_CreateVehicle') === undefined) {
        this.disableCreateVehicle = true
      } else {
        this.disableCreateVehicle = Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_Disable_CreateVehicle')?.Data1 === 'true' ?? false
      }
      // console.log('pip', Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_Disable_CreateVehicle'))
      // this.showCancelDialog = Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_Show_Cancel_Dialog')?.Data1 === 'true' ?? false
      var noValue = Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_Show_Finish_Dialog')?.Data1 === undefined ?? false
      if (noValue) {
        this.showFinishDialog = true
      } else {
        this.showFinishDialog = Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_Show_Finish_Dialog')?.Data1 === 'true' ?? false
      }
      noValue = Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_Show_Enter_Button')?.Data1 === undefined ?? false
      if (noValue) {
        this.showEnterButton = true
      } else {
        this.showEnterButton = Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_Show_Enter_Button')?.Data1 === 'true' ?? false
      }
      noValue = Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_Show_RemoveTare_Dialog')?.Data1 === undefined ?? false
      if (noValue) {
        this.showClearTareDialog = true
      } else {
        this.showClearTareDialog = Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_Show_RemoveTare_Dialog')?.Data1 === 'true' ?? false
      }
      noValue = Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_Show_UseTare_Dialog')?.Data1 === undefined ?? false
      if (noValue) {
        this.showSaveTareDialog = true
      } else {
        this.showSaveTareDialog = Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_Show_UseTare_Dialog')?.Data1 === 'true' ?? false
      }
      noValue = Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_Show_Transfer_RegistrationCheckbox')?.Data1 === undefined ?? false
      if (noValue) {
        this.showTransferCheckBox = false
      } else {
        this.showTransferCheckBox = Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_Show_Transfer_RegistrationCheckbox')?.Data1 === 'true' ?? false
      }
      noValue = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === undefined ?? false
      if (noValue) {
        this.useFacilityDescription = false
      } else {
        this.useFacilityDescription = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === 'true' ?? false
      }

      noValue = Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_CamDelayEnabled')?.Data1 === undefined ?? false
      if (noValue) {
        this.camDelayEnabled = false
      } else {
        this.camDelayEnabled = Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_CamDelayEnabled')?.Data1 === 'true' ?? false
        noValue = Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_CamDelay')?.Data1 === undefined ?? false
        if (noValue) {
          this.camDelay = 5
        } else {
          this.camDelay = Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_CamDelay')?.Data1
        }
      }
    }

    if (this.$route.params.id) {
      this.readonlyFacility = true
      this.id = this.$route.params.id // for Create/Edit support in TitleText
      this.smReg.id = this.$route.params.id
      const res = await ScanMobile.loadRegistration(this.smReg.id)
      if (!res.failed) {
        this.form.facilityNo = res.data.Facility
        this.updateUi()
        this.form.vehicleNo = res.data.Registration.VehicleNo
        this.form.agreementNo = res.data.Registration.AgreementNo
        // Load only this vehicle into form.vehicles so LicensPlate is visible and dropdown works
        const changeVehicle = false // Do NOT change vehicle (and article)
        if (this.form.vehicleNo) { this.loadVehicle(this.form.vehicleNo, changeVehicle) } else this.form.vehicles = [this.$t('Search')]
        this.form.vehicleName = res.data.Registration.VehicleName
        this.form.vehicleLicensePlateNo = res.data.Registration.VehicleLicensePlateNo
        this.form.deliveryNo = res.data.Registration.DeliveryNo
        this.form.customerNo = res.data.Registration.CustomerNo
        this.form.articleNo = res.data.Registration.ArticleNo
        this.form.plantNo = res.data.Registration.PlantNo
        this.form.carrierNo = res.data.Registration.CarrierNo
        this.form.requisitionNo1 = res.data.Registration.RequisitionNo1
        this.form.requisitionNo2 = res.data.Registration.RequisitionNo2
        this.form.comment1 = res.data.Registration.Comment1

        this.smReg.registrationId = res.data.RegistrationId
        this.smReg.facilityNo = res.data.Facility
        this.smReg.finishedDate = res.data.FinishedDate
        this.smReg.finishedBy = res.data.FinishedBy
        this.smReg.comment = res.data.Comment
        this.smReg.Registration = res.data.Registration
        this.weightFirst = this.smReg.Registration.WeightFirst
        this.firstReg = false
        this.orgFirstReg = false
        this.showSaveButton = true
        this.form.facilityDisplay = this.form.facilityNo
        this.form.storage1 = res.data.Storage1
        this.form.storage2 = res.data.Storage2
      }
    } else {
      this.readonlyFacility = this.isReadonly('Facility') // can be setup ReadOnly
      const storedFacilityNo = '' + LocalStorage.load('facilityNo')
      if (storedFacilityNo) {
        this.form.facilityNo = '' + LocalStorage.load('facilityNo')
      }
      this.form.facilityDisplay = this.form.facilityNo
      this.facilityChanged()
      const res = await ScanMobile.getVehicleNr({ Facility: this.form.facilityNo, No: '0' })
      if (!res.failed) {
        if (res.data != null) {
          this.userVehicleNo = res.data.No
        }
      }
      var noAgreementLoad = false
      if (this.storageNo != null && this.storageNo !== '') {
        noAgreementLoad = true
      }
      if (this.userVehicleNo !== '') {
        this.form.vehicleNo = this.userVehicleNo.toString()
        const changeVehicle = true // Also change vehicle and article
        await this.loadVehicle(this.userVehicleNo.toString(), changeVehicle, noAgreementLoad) // When loaded also set ArticleNo from LocalStorage or if exists from Vehicle (and other fields from Vehicle)
      } else {
        // Load current (stored) VehicleNo
        /* const currentRegVehicleNo = LocalStorage.load('currentRegVehicleNo')
        if (currentRegVehicleNo) {
          this.form.vehicleNo = currentRegVehicleNo.toString()
          const changeVehicle = true // Also change vehicle and article
          this.loadVehicle(currentRegVehicleNo.toString(), changeVehicle) // When loaded also set ArticleNo from LocalStorage or if exists from Vehicle (and other fields from Vehicle)
        } else { LocalStorage.remove('currentRegVehicleNo') } */
      }

      if (this.storageNo != null && this.storageNo !== '') {
        var resA = await ScanMobile.loadAgreementFromDelivery({ Facility: this.form.facilityNo, No: this.storageNo })
        if (!resA.failed) {
          if (resA.data.length === 1) {
            await this.loadAgreement(resA.data[0].No).then(() => {
              this.form.agreementNo = resA.data[0].No
              this.form.deliveryNo = this.storageNo
            })
          }
        }
      }

      if (this.$route.params.sType === 'Up') {
        this.form.storage1 = this.storageNo
        this.formT.storage1 = this.storageNo
      } else if (this.$route.params.sType === 'Down') {
        this.form.storage2 = this.storageNo
        this.formT.storage2 = this.storageNo
      }
      this.textBtnText = '1. Registration'
      this.updateUi()
    }

    this.$nextTick(() => {
      this.loading = false
    })
    if (this.showSaveButton) {
      this.manualIndicator = true
    }

    if (!this.manualIndicator) {
      console.log('Starting Timer')
      this.getLiveWeightTimer = setInterval(async () => {
        // Only check IsAlive, if last check has ended
        // this.enableVT25WeightIntegration &&
        if (this.activeVT25 && !this.manualIndicator) {
          this.checkkingIsAlive = true
          const res = await ScanMobile.getWeight({ VT25Id: this.activeVT25, ResetWeight: 'False' })
          if (res.failed) {
            this.isAlive = false
            this.displayWeight = '�'
            this.firstErrorStatus = 'No connection'
            this.$root.$message.showError('GetWeight for "' + this.activeVT25 + '" errors')
          } else {
            this.displayWeight = res.data.WeightKg.toString()
            if (this.firstReg && ((this.tempTareValue === null || this.tempTareValue === 0) && !this.tareVehicle)) {
              this.weightFirst = res.data.WeightKg
            } else {
              if (this.tempTareValue != null && this.tempTareValue.Value > 0) {
                this.weightFirst = this.tempTareValue.Value
                this.weightSecond = res.data.WeightKg
              }
              if (this.showSaveButton) {
                this.weightFirst = res.data.WeightKg
              } else if (!this.firstReg) {
                this.weightSecond = res.data.WeightKg
              }
              if (this.tareVehicle) {
                this.weightFirst = this.tareValue
                this.weightSecond = res.data.WeightKg
              }
            }
            this.weightNet = Math.abs(this.weightFirst - this.weightSecond)
            this.firstErrorStatus = res.data.ErrorMsg
            this.isStable = res.data.IsStable
            if (res.data.IsStable) {
              this.WeightNet = res.data.WeightKg
            } else {
              this.WeightNet = res.data.WeightKg // + ' ~ '
            }
            if (this.firstErrorStatus !== '') {
              this.displayWeight = '-9999'
              this.isStable = false
            }
            if (!this.isAlive) this.isAlive = true
          }
          this.checkkingIsAlive = false
        }
      }, 2000)
    }
  }
}
</script>

<style>
.licensplate-input input {
  text-transform: uppercase
}
</style>
